import type { ReactNode } from 'react';

import { classFilter } from '@shieldpay/theme-provider-ui/utilities';

import { Box } from '../box/box';
import { Text } from '../text/text';

import { variantConfig } from './util';

import * as styles from './pill.css';

export interface PillProps {
  variant?: keyof typeof variantConfig;
  children: ReactNode;
  'data-testid'?: string;
}

const TEST_IDS = {
  PILL: 'pill-component',
  TEXT: 'pill-component-text',
};

export const Pill = ({
  variant = 'default',
  children,
  'data-testid': testId = TEST_IDS.PILL,
}: PillProps) => (
  <Box
    padding={{ x: 'baseNeg3' }}
    className={classFilter([styles.pill])}
    size={{ maxWidth: 'basePos11' }}
    variant="inline-flex"
    alignContent={{ y: 'center' }}
    spacing="baseNeg6"
    data-testid={testId}
    {...variantConfig[variant]}
  >
    <Text truncate variant="caption" data-testid={TEST_IDS.TEXT}>
      {children}
    </Text>
  </Box>
);
